// extracted by mini-css-extract-plugin
export var bubble = "_3h-0";
export var container = "_3h-3";
export var contrastBorder = "_3h-4";
export var greyOut = "_3h-2";
export var initialsWrapper = "_3h-1";
export var large = "_3h-9";
export var medium = "_3h-8";
export var mediumSmall = "_3h-7";
export var mediumSmallMedium = "_3h-c";
export var micro = "_3h-5";
export var small = "_3h-6";
export var tiny = "_3h-b";
export var xTiny = "_3h-a";